import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../lib/i18n";
import { useSettings } from "../../lib/queries";

export default function Process() {
  const { data: settings } = useSettings();
  const { t, lang } = useLang();
  const steps = settings?.process_steps || [];

  return (
    <section id="process" data-testid="process-section" className="py-32 relative bg-[#0A0A11] border-y border-white/5 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#A855F7]" />
            <span className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] uppercase">
              {t("process_kicker")}
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase tracking-tighter text-white leading-[0.95]">
            {t("process_title")}
          </h2>
        </div>

        <div className="space-y-6">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`process-step-${i + 1}`}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="relative group border-t border-white/10 py-8 hover:border-[#A855F7]/40 transition-colors"
            >
              <div className="grid grid-cols-12 items-center gap-6">
                <div className="col-span-3 md:col-span-2 font-display text-6xl md:text-8xl text-white/5 group-hover:text-[#A855F7]/25 transition-colors leading-none">
                  0{i + 1}
                </div>
                <div className="col-span-9 md:col-span-8">
                  <h3 className="font-display text-3xl md:text-5xl uppercase tracking-tighter text-white leading-none">
                    {lang === "tr" ? s.tr : s.en}
                  </h3>
                </div>
                <div className="hidden md:block col-span-2 text-right">
                  <span className="font-mono-ui text-[10px] tracking-widest text-white/40 uppercase">
                    Step {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
}
